import script from "./PartnerContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerContactModal.vue?vue&type=script&setup=true&lang=js"

import "./PartnerContactModal.vue?vue&type=style&index=0&id=48798190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48798190"]])

export default __exports__